export default {
    namespaced: true,
    state: () => ({
        search: '',
        year: '-1',
        tableOptions:
        {
            page: 1,
            itemsPerPage : 15,
            sortBy : [ "controldate" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
    }),
    mutations: {
        SET_SEARCH (state, payload){
            state.search = payload;
        },
        SET_YEAR (state, payload){
            state.year = payload;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
    },
    getters: {
        getSearch: (state) => state.search,
        getYear: (state) => state.year,
        getTableOptions: (state) => state.tableOptions,
    }
}